import React from 'react';

function AddExperienceCard() {
  return (
    <button className='bg-white shadow rounded-lg  w-full border-opacity-100 overflow-hidden border border-color-yellow p-4 mb-4'>
      <div className='flex flex-row '>
        <img
          id='output'
          src='https://ui-avatars.com/api/?name=John+Doe'
          className='w-10 h-10 rounded-full object-cover'
          alt=''
        />
        <div className='m-2 mx-4'>
          <i class='fas fa-pen text-color-yellow' />
        </div>
        <div className='text-xs text-black m-2'>
          Erzähle uns Deine Erfahrung und hilf anderen
        </div>
      </div>
    </button>
  );
}

export default AddExperienceCard;
